/**
 * PortalUser
 *
 * Handles the setting and getting of a users details.
 */

// the constructor for this object
function PortalUser() { }

// the object
PortalUser.prototype = {
    constructor: PortalUser,
    
    // make the api call to get the user data
    // dataBack is used by PortalLogin to confirm completion
    setUser: function(successCallback)
    {
        var userRequest = new PortalRequest;
        userRequest.makeRequest(
            '/users/get-authenticated-user',
            {},
            function(data, code, message) {
                PortalMain.PortalUser._storeUserData(data);
                successCallback(true);
            },
            function () {
                successCallback(false);
            }
        );
    },
    
    // clear the user details from localstorage
    clearUser: function()
    {
        localStorage.removeItem('portalUser');
    },
    
    // get the user
    getUser: function() 
    {
        if (localStorage.portalUser) {
            var userData = JSON.parse(localStorage.portalUser);
            return userData;
        }
        
        return false;
    },
    
    // save the users data to localstorage
    _storeUserData: function(userData)
    {
        userData = JSON.stringify(userData);
        localStorage.setItem('portalUser', userData);
    },
    
}
